// TrendingGrid.tsx — 4-col hover-lift destination grid for HomePage.
// 4-col desktop, 2-col tablet/mobile. Uses DestinationCard.

import { useState } from 'react';
import { DestinationCard } from '@/components/DestinationCard';
import { Chip } from '@/components/primitives';
import { TRENDING_DESTINATIONS } from '@/lib/destinations-mock';

const F = '"Inter Variable","Inter",system-ui,sans-serif';
const DISPLAY = '"Fraunces Variable","Fraunces",Georgia,serif';

type Vibe = 'All' | 'Beach' | 'City' | 'Nature' | 'Romantic' | 'Foodie';

const VIBES: Vibe[] = ['All', 'Beach', 'City', 'Nature', 'Romantic', 'Foodie'];

export function TrendingGrid() {
  const [activeVibe, setActiveVibe] = useState<Vibe>('All');

  const filtered = activeVibe === 'All'
    ? TRENDING_DESTINATIONS
    : TRENDING_DESTINATIONS.filter(d => d.vibes.includes(activeVibe));

  return (
    <div style={{ padding: '64px clamp(16px, 4vw, 64px) 0' }}>
      {/* Header */}
      <div style={{
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'space-between',
        marginBottom: 28,
      }}>
        <div>
          <div style={{
            fontFamily: F, fontSize: 11, letterSpacing: 2.5,
            color: '#8C98B0', fontWeight: 600,
          }}>EDITORIALLY PICKED</div>
          <h2 style={{
            fontFamily: DISPLAY,
            fontSize: 'clamp(36px,4.5vw,60px)',
            fontWeight: 500,
            color: '#F4F3F0',
            margin: '8px 0 0',
            letterSpacing: -0.025,
            lineHeight: 0.95,
          }}>Going up.</h2>
        </div>

        {/* Vibe filter chips */}
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', justifyContent: 'flex-end' }}>
          {VIBES.map(v => (
            <Chip
              key={v}
              active={activeVibe === v}
              onClick={() => setActiveVibe(v)}
            >
              {v}
            </Chip>
          ))}
        </div>
      </div>

      {/* Auto-fit grid — 4 cols on desktop, 2 in the middle, 1 on narrow phones */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
        gap: 18,
      }}>
        {filtered.slice(0, 8).map(dest => (
          <DestinationCard key={dest.id} destination={dest} />
        ))}
      </div>
    </div>
  );
}
